import {
  transformCurrencyAmountDto,
  transformCurrencyConversionDto,
  transformCurrencyConversionWithMoneyObjectDto,
} from '@marketplace-web/currency/currency-data'

import {
  BundleSummaryDto,
  BundleSummaryModel,
  InstantBundleSummaryDto,
  InstantBundleSummaryModel,
} from '../types/bundle-summary'

export const transformBundleSummaryDto = ({
  discount_amount,
  discount_applied,
  discount_explanation,
  discount_fraction,
  discount_text,
  full_price,
  price,
  shipping_price,
  show,
  total_price,
  currency,
  offline_verification_fee,
  buyer_protection_fee,
  price_with_buyer_protection_fee,
  conversion,
  electronics_verification_fee,
  contains_electronics_verification_item,
  contains_offline_verification_item,
}: BundleSummaryDto): BundleSummaryModel => ({
  discountAmount: discount_amount && transformCurrencyAmountDto(discount_amount),
  discountApplied: discount_applied,
  discountExplanation: discount_explanation,
  discountFraction: discount_fraction,
  discountText: discount_text,
  fullPrice: full_price && transformCurrencyAmountDto(full_price),
  price: transformCurrencyAmountDto(price),
  shippingPrice: shipping_price && transformCurrencyAmountDto(shipping_price),
  show,
  totalPrice: transformCurrencyAmountDto(total_price),
  currency,
  offlineVerificationFee:
    offline_verification_fee && transformCurrencyAmountDto(offline_verification_fee),
  buyerProtectionFee: transformCurrencyAmountDto(buyer_protection_fee),
  priceWithBuyerProtectionFee: transformCurrencyAmountDto(price_with_buyer_protection_fee),
  conversion: conversion && transformCurrencyConversionDto(conversion),
  electronicsVerificationFee:
    electronics_verification_fee && transformCurrencyAmountDto(electronics_verification_fee),
  containsElectronicsVerificationItem: contains_electronics_verification_item,
  containsOfflineVerificationItem: contains_offline_verification_item,
})

export const transformInstantBundleSummaryDto = ({
  discount_amount,
  discount_applied,
  discount_explanation,
  discount_fraction,
  discount_text,
  total_price,
  shipping_price,
  offline_verification_fee,
  buyer_protection_fee,
  price_with_buyer_protection_fee,
  conversion,
  items_price,
  bundle_shipping_type,
  contains_offline_verification_item,
  contains_electronics_verification_item,
  electronics_verification_fee,
}: InstantBundleSummaryDto): InstantBundleSummaryModel => ({
  discountAmount: discount_amount ? transformCurrencyAmountDto(discount_amount) : null,
  discountApplied: discount_applied,
  discountExplanation: discount_explanation,
  discountFraction: discount_fraction,
  discountText: discount_text,
  offlineVerificationFee:
    offline_verification_fee && transformCurrencyAmountDto(offline_verification_fee),
  buyerProtectionFee: transformCurrencyAmountDto(buyer_protection_fee),
  priceWithBuyerProtectionFee: transformCurrencyAmountDto(price_with_buyer_protection_fee),
  conversion: conversion && transformCurrencyConversionWithMoneyObjectDto(conversion),
  itemsPrice: transformCurrencyAmountDto(items_price),
  totalPrice: transformCurrencyAmountDto(total_price),
  shippingPrice: shipping_price ? transformCurrencyAmountDto(shipping_price) : null,
  bundleShippingType: bundle_shipping_type,
  containsOfflineVerificationItem: contains_offline_verification_item,
  containsElectronicsVerificationItem: contains_electronics_verification_item,
  electronicsVerificationFee:
    electronics_verification_fee && transformCurrencyAmountDto(electronics_verification_fee),
})
